import React, { useContext } from "react";
import { TableComponents } from "./TableComponents.tsx";
import { Schedule } from "../../../../models/Schedule.tsx";
import { FaTv } from "react-icons/fa";
import { TeaserGameTeam } from "./TeaserGameTeam.tsx";

interface IParlaygameComponents {
    game: Schedule,
    setShowLimitAlert: React.Dispatch<React.SetStateAction<boolean>>,
    showHeaderByLeague: boolean;
    showHeaderByDate: boolean;
    setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export function TeaserGames(props: IParlaygameComponents) {

    const { game, showHeaderByLeague, showHeaderByDate, setShowLimitAlert, setErrorMessage } = props;
    const currentGame = game as Schedule;
    const gameTimeDate = new Date(game.start_date ?? '')
    const time = gameTimeDate.toLocaleTimeString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: "short"
    });
    const formattedDate = new Date(game.start_date).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
    }).toUpperCase();

    const totalMarkets = [
        'Total Points',
        'Total Runs',
        'Total Goals',
    ];

    const teamAway = game.odds?.filter(odd => odd.selection === game.away_team_display) ?? [];
    const teamHome = game.odds?.filter(odd => odd.selection === game.home_team_display) ?? [];

    teamHome.push(...(game.odds?.filter(odd => totalMarkets.includes(odd.market) && odd.selection_line === 'under') ?? []));
    teamAway.push(...(game.odds?.filter(odd => totalMarkets.includes(odd.market) && odd.selection_line === 'over') ?? []));

    return (
        <>
            {showHeaderByLeague && (<TableComponents game={currentGame} />)}
            <div className='gamesGroup'>
                {showHeaderByDate && (
                    <div className='d-flex'>
                        <div className="header-table">
                            <div className="container-date team-name-container">
                                <span className="group ps-1">{formattedDate}</span>
                                {/* <span className="group">MAX:</span> */}
                            </div>
                            <div className="spread-container center-items">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="moneyline-container center-items d-none d-lg-block">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="total-container center-items">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                            <div className="over-under-container center-items d-none d-lg-block">
                                {/* <span className='group'>${user?.wagerLimit}</span> */}
                            </div>
                        </div>
                    </div>
                )}
                <div className='d-flex'>
                    <span className="group-text teko">{time}</span>
                    <div className="live">
                        <FaTv className='broadcast teko' /><span className='broadcast teko'>{game.broadcast}</span>
                    </div>
                </div>
                <div>
                    <TeaserGameTeam
                        gameId={currentGame.game_id!}
                        sport={currentGame.sport.name}
                        gameTime={gameTimeDate}
                        team={currentGame.away_team_display!}
                        league={currentGame.league.name}
                        odds={teamAway}
                        setShowLimitAlert={setShowLimitAlert}
                        isHomeTeam={false}
                        fixture_id={currentGame.id}
                        gameLogo={game.away_competitors[0]?.logo}
                        teaserPoints={game.teaserPoints}
                        teaserType={game.teaserType}
                        opposingTeam={game.home_team_display}
                        setErrorMessage={setErrorMessage}

                    />
                    <TeaserGameTeam
                        gameId={currentGame.game_id!}
                        sport={currentGame.sport.name}
                        gameTime={gameTimeDate}
                        team={currentGame.home_team_display!}
                        league={currentGame.league.name}
                        odds={teamHome}
                        setShowLimitAlert={setShowLimitAlert}
                        isHomeTeam={true}
                        fixture_id={currentGame.id}
                        gameLogo={game.home_competitors[0]?.logo}
                        teaserPoints={game.teaserPoints}
                        teaserType={game.teaserType}
                        opposingTeam={game.away_team_display}
                        setErrorMessage={setErrorMessage}

                    />
                </div>
            </div>
        </>
    )
}